import { withStyles } from '@bruitt/classnames'
import { FC } from 'react'

import { SvgNextPagination } from '@/uikit/svg'
import { usePagination, DOTS } from './use-pagination'

import styles from './pagination.module.scss'

interface PaginationProps {
  onPageChange: any
  totalCount: number
  siblingCount?: number
  currentPage: number
  pageSize: number
}

const sx = withStyles(styles)

export const Pagination: FC<PaginationProps> = (props) => {
  const { onPageChange, totalCount, siblingCount = 1, currentPage, pageSize } = props

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  })

  if (currentPage === 0 || paginationRange.length < 2) {
    return null
  }

  const onNext = () => {
    onPageChange(currentPage + 1)
  }

  const onPrevious = () => {
    onPageChange(currentPage - 1)
  }

  let lastPage = paginationRange[paginationRange.length - 1]

  return (
    <ul className={styles.container}>
      <li
        className={sx('item', {
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        <div className={styles.arrow}>
          <SvgNextPagination />
        </div>
      </li>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <li key={index} className={sx('item', 'dots')}>
              &#8230;
            </li>
          )
        }

        return (
          <li
            key={index}
            className={sx('item', {
              selected: pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        )
      })}
      <li
        className={sx('item', {
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        <div className={sx('arrow', 'right')}>
          <SvgNextPagination />
        </div>
      </li>
    </ul>
  )
}
